
<v-card
    flat
    rounded
    :class="background"
    :ripple="false"
>
    <div class="lm-border pa-3 pt-3" style="height: 90px" >
        <div class="v-flex" style="justify-content: space-between">
            <div style="margin-top: -3px; margin-left: -6px;" v-if="selected ||deleteable">
                <a @click="onMinus">
                    <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                </a>
            </div>
            <div style="font-size: 15px; padding-top: 1px;">
                <span
                    :class="active ? 'primary--text' : 'lightgray'"
                >
                    {{ site.fabricNo }}
                </span>
            </div>
            <div
                v-if="site.limSince"
                class="pl-1 secondary--text"
                style="font-size: 13px; padding-top: 3px;"
            >
                seit {{ date (site.limSince) }}
            </div>
            <v-spacer/>
            <div class="site-customer">
               <span v-if="site.contracttype">{{ site.contracttype }} - </span><span>{{ site.customer.name }}</span>
            </div>
            <div style="margin-top: -2px; margin-right: -7px;">
                <c-site-icon
                    :site="site"
                    @selected="onSite(site)"
                />
            </div>
        </div>
        <div class="card-subtitle" style="margin-top: -6px;">
            {{ site.street }}, {{ site.zip }} {{ site.city }}
        </div>
        <div class="card-subtitle">
            {{ site.ve }}  {{ site.ve && site.ve2 ? ' / ' : ''  }}  {{ site.ve2 }}
        </div>
    </div>
</v-card>
